import styled from 'styled-components'

// Styled components
export const Footer = styled.div`
    margin-top: 7rem;
    overflow: hidden;
    height: 7rem;

    background: rgb(36, 43, 54);
    padding: 3rem 5rem;

    h1, h2, h3, li, a {
        color: #eee;
    }

    a {
        text-decoration: none;
        cursor: pointer;
    }

    h3 {
        display: block;
        margin: 0;
        margin-top: 1rem;
    }

    h1 {
        float: right;
        text-align: right;
        font-family: "Bebas Neue";
    }

    ul {
        padding: 0;
        display: inline-block;
    }

    li {
        margin-top: 1rem;
        list-style: none;
        display: block;
    }
    
    li .svg-inline--fa{
        cursor: pointer;
        margin-right: 1rem;
    }

    li a:hover {
        color: rgb(38, 125, 255);
    }
    
    @media (max-width: 500px) {
        font-size: .9rem;
        padding: 1rem 2rem 4rem 2rem;

        h3 {
            margin-top: 3rem;
        }
    }
`
